// https://stash.aexp.com/stash/projects/ONE/repos/amex-iguazu-resources/browse/src/memberProducts.js
const memberProducts = {
  fetch: (id, action, state) => ({
    url: `${state.getIn(['config', 'productDomain'])}/api/servicing/v1/member`,
    opts: {
      credentials: 'include',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    },
  }),
};

export default memberProducts;
